import { FC } from 'react'
import { ICard } from '../../../types/card'
import { useTypedSelector } from '../../../hooks/useTypedSelector'
import { getUserAvatar, getUserLink, getUserName } from '../../../utils/methods'
import { CardFile } from './File'
import { Link } from 'react-router-dom'

export const PremiumDetail: FC<{
    card: ICard
}> = ({ card }) => {
    const { auth } = useTypedSelector((s) => s)
    return (
        <div className="premium">
            {card.User && (
                <Link to={getUserLink(card.User)} className="premium__link">
                    <div className="premium__avatar">
                        <img src={getUserAvatar(auth.avatar)} alt="" />
                    </div>
                    <div className="premium__name">{getUserName(auth)}</div>
                    <div className="premium__metaname">{auth.metaName}</div>
                </Link>
            )}

            <div className="premium__title">{card.name}</div>
            {!!card.description.length && (
                <pre className="premium__description">{card.description}</pre>
            )}
            <div className="premium__content">
                <CardFile card={card}></CardFile>
            </div>
        </div>
    )
}
